import {
    SHOW_SUCCESSFUL_MESSAGE,
    SHOW_INFO_MESSAGE,
    SHOW_WARNING_MESSAGE,
    SHOW_ERROR_MESSAGE,
    LOGGED_IN_MESSAGE,
    UPDATE_SHOW_LOADING,
    USER_LOGOUT,
    ON_USER_PICTURE_CHANGE,
    UPDATE_SHOW_MESSAGE,
    ON_ROUTE_CHANGE, ON_NOTIFICATION_RECEIVED
} from 'reducers/constants';

import Auth from "auth/Auth";
import HttpClient from "utils/HttpClient/HttpClient";
import RegisterFirebase from "components/Helpers/RegisterFirebase";

export const onRouteChange = (message) => dispatch => {
    dispatch(
        {
            type: ON_ROUTE_CHANGE,
            payload: message
        }
    );
}

export const showSuccessfulMessage = (message) => dispatch => {
    dispatch(
        {
            type: SHOW_SUCCESSFUL_MESSAGE,
            payload: message
        }
    );
}

export const showInfoMessage = (message) => dispatch => {
    dispatch(
        {
            type: SHOW_INFO_MESSAGE,
            payload: message
        }
    );
}

export const showWarningMessage = (message) => dispatch => {
    dispatch(
        {
            type: SHOW_WARNING_MESSAGE,
            payload: message
        }
    );
}

export const showErrorMessage = (message) => dispatch => {
    dispatch(
        {
            type: SHOW_ERROR_MESSAGE,
            payload: message
        }
    );
}

export const setLoggedInMessage = (value) => dispatch => {
    dispatch(
        {
            type: LOGGED_IN_MESSAGE,
            payload: value
        }
    );
}

export const updateShowLoading = (value) => dispatch => {
    dispatch(
        {
            type: UPDATE_SHOW_LOADING,
            payload: value
        }
    );
}

export const notifications = (message) => dispatch => {
    dispatch(
        {
            type: ON_NOTIFICATION_RECEIVED,
            payload: message
        }
    );
}


export const updateShowMessage = (value) => dispatch => {
    dispatch(
        {
            type: UPDATE_SHOW_MESSAGE,
            payload: value
        }
    );
}

export const onUserPictureChange = (base64) => dispatch => {
    dispatch(
        {
            type: ON_USER_PICTURE_CHANGE,
            payload: base64
        }
    );
}

export const changePassword = (data) => dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    new HttpClient(true).post("oga/change-password", data, config)
        .then((response) => {
            dispatch({ type: SHOW_SUCCESSFUL_MESSAGE, payload: "Contraseña cambiada correctamente." });
        })
        .catch((error) => {
            dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
        })
}


export const logout = () => dispatch => {
    new RegisterFirebase().deleteToken(new Auth().logout());
    dispatch(
        {
            type: USER_LOGOUT,
            payload: {}
        }
    );
}


// WEBPACK FOOTER //
// ./src/reducers/application/applicationActions.js